<template>
  <div>
    <h2 style="padding-bottom: 20px;">{{ $route.meta.fullname }}</h2>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Index',

  data() {
    return {}
  },

  mounted() {
    console.log(this.$route.meta)
  },

  methods: {}
}
</script>

<style lang="scss" scoped></style>
